module.exports = __webpack_public_path__ + "6a010666f02435cc40906c5d90779c0f.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/areas/areas-guardianship-circle.png
// module id = 119
// module chunks = 0